import { FC } from 'react';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';

interface PermissionSection {
    key: string;
    className?: string;
}

const ConsentPermissions: FC = () => {
    const translate = useTranslate('consent');

    const sections: (string | PermissionSection)[] = [
        {
            key: 'permissions',
            className: 'consent-permissions-title',
        },
        {
            key: 'consentDetails.accountDetails',
            className: 'consent-permissions-header',
        },
        'consentDetails.accountNameAndSortCode',
        'consentDetails.accountBalance',
        {
            key: 'consentDetails.accountTransactions',
            className: 'consent-permissions-header',
        },
        'consentDetails.incomingTransactions',
        'consentDetails.outgoingTransactions',
        'consentDetails.incomingTransactionDetails',
        'consentDetails.outgoingTransactionDetails',
        {
            key: 'consentDetails.regularPayments',
            className: 'consent-permissions-header',
        },
        'consentDetails.directDebits',
        'consentDetails.standingOrder',
        'consentDetails.scheduledPayments',
    ];

    return (
        <div className="consent-permissions">
            {sections.map(item => {
                const key = typeof item === 'string' ? item : item.key;
                const className =
                    typeof item === 'object' ? item.className : '';

                return (
                    <Typography key={key} tag="p" className={className}>
                        {translate(key)}
                    </Typography>
                );
            })}
        </div>
    );
};

export default ConsentPermissions;
